import { css } from 'lit';

export const globalStyle = css`
  [hidden],
  .hidden {
    display: none;
  }

  .callout {
    background-color: #f4f4f4;
    font-size: 0.875em;
    line-height: 1.5em;
    margin: 1em 0;
    padding: 0 1.5em;
    text-align: center;

    &.warning {
      background-color: #fcd5d1;
      border: 1px solid #cc2427;
    }
  }
`;
